import { useApi } from "@api/ApiProvider";
import { useCallback, useState } from "react";

export const useReauthentication = () => {
  const { needsReauth, reauthenticate } = useApi();
  const [isReauthenticating, setIsReauthenticating] = useState(false);

  const handleReauthenticate = useCallback(async () => {
    setIsReauthenticating(true);
    try {
      await reauthenticate();
    } finally {
      setIsReauthenticating(false);
    }
  }, [reauthenticate]);

  return {
    needsReauth,
    isReauthenticating,
    handleReauthenticate,
  };
};
